export var stagingLinkPreferencesUrl = 'https://id.stg.internal.atlassian.com/manage-profile/link-preferences';
export var productionLinkPreferencesUrl = 'https://id.atlassian.com/manage-profile/link-preferences';